import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import State from 'src/models/State';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Vendor from 'src/models/AP/Vendor';

interface IAddVendorExDialogProps {
    dialogName: string;
    handleVendor?: (vendorName: string) => void;
    hideDialog: () => void;
    states: State[];
    termDescriptions: { value: string; label: string; }[];
    createVendor?: (payload: Vendor) => void;
}

const AddVendorExDialog = (props: IAddVendorExDialogProps) => {
    const { register, errors, handleSubmit } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        onCreate();
    }, [props.dialogName]);

    const onCreate = () => {
        console.log('AddVendorDialog onCreate()');
    };

    const OKClicked = () => {
        props.hideDialog();
    };

    const stateDropdownOptions = () => {
        return props?.states
            ? props?.states?.map((st: State) => {
                return { value: st.id, label: st.name };
            })
            : [];
    };

    const onSubmit = async (data: Vendor) => {
        props.createVendor(data);
    };

    return (
        <Dialog title="Add Vendor" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '35%' }}>
            <form id="employeePayForm" onSubmit={handleSubmit(onSubmit)}>

                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row">
                                        <RHFInputBox
                                            disabled={true}
                                            label="Vendor No."
                                            name={`vendorNumber`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="Name"
                                            name={`vendorName`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFCheckbox
                                            name="isActive"
                                            label="Active"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{width: '20%', marginTop: '1rem' }}
                                            style={{verticalAlign: 'middle'}}
                                        />
                                        <RHFInputBox
                                            name={`documents`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '10%', marginTop: '2rem' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Address"
                                            name={`address`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="City"
                                            name={`city`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFSelect
                                            bodyStyle={{ width: '20%' }}
                                            style={{ width: '100%' }}
                                            name="stateId"
                                            label="State"
                                            options={stateDropdownOptions()}
                                            register={register}
                                            errors={errors}
                                        />
                                        <RHFInputBox
                                            label="Zip Code"
                                            name={`zipcode`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Phone"
                                            name={`phone`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="FAX"
                                            name={`fax`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFInputBox
                                            label="E-Mail"
                                            name={`email`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                        <RHFSelect
                                            label="Tax ID No."
                                            name="taxIdNumber"
                                            options={[
                                                { value: 'EIN', label: 'EIN' },
                                                { value: 'SSN', label: 'SSN' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFSelect
                                            label="Terms"
                                            name="terms"
                                            options={props?.termDescriptions ? props?.termDescriptions : [
                                                { value: 'Upon Receipt', label: 'Upon Receipt' },
                                                { value: 'Net 15', label: 'Net 15' },
                                                { value: 'Net 30', label: 'Net 30' },
                                                { value: 'Net 45', label: 'Net 45' },
                                                { value: 'Other', label: 'Other' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%', marginLeft: '.5rem' }}
                                        />
                                        <RHFSelect
                                            label="IRS Category Type"
                                            name="irsCategoryType"
                                            options={[
                                                { value: 'Gross Proceeds Paid to Attorney', label: 'Gross Proceeds Paid to Attorney' },
                                                { value: 'Nonemployee Compensation', label: 'Nonemployee Compensation' },
                                                { value: 'Not Defined', label: 'Not Defined' },
                                                { value: 'Not Eligible - Entity Type', label: 'Not Eligible - Entity Type' },
                                                { value: 'Not Eligible - Other', label: 'Not Eligible - Other' },
                                                { value: 'Not Eligible - Vendor Type', label: 'Not Eligible - Vendor Type' },
                                                { value: 'Other Income', label: 'Other Income' },
                                                { value: 'Rents', label: 'Rents' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFInputBox
                                            label="Vendor Account for TSDI"
                                            name={`vendorAccountForTSDI1`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                        <RHFInputBox
                                            label=" "
                                            name={`vendorAccountForTSDI2`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    type="submit"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Save'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
                                </div>
            </form>
        </Dialog>
    );
};

export default AddVendorExDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/AddVendorExDialog.tsx